// src/components/AuthCard.js
// The centered Post Calendar card used by the signed-out pages.
import React from 'react';
import LogoMark from './LogoMark';
import { Link } from 'react-router-dom';

export const alertStyle = (kind) => ({
  padding: '10px 12px', borderRadius: 6, fontSize: 12, marginBottom: 14, lineHeight: 1.5,
  ...(kind === 'error' ? { background: '#feeaea', color: '#b91c1c' } : { background: '#e6f9f0', color: '#0a6640' }),
});

export const fullWidthBtn = { width: '100%', justifyContent: 'center', padding: '10px', fontSize: 14 };
export const linkStyle = { color: '#0f766e', fontWeight: 600 };

// Shown under the signed-out cards; Google verification wants the legal pages linked.
export function LegalLinks() {
  return (
    <div style={{ textAlign: 'center', marginTop: 16, fontSize: 11, color: '#a0a8b8' }}>
      <Link to="/" style={{ color: 'inherit' }}>Home</Link> · <Link to="/privacy" style={{ color: 'inherit' }}>Privacy Policy</Link> · <Link to="/terms" style={{ color: 'inherit' }}>Terms of Service</Link>
    </div>
  );
}

export default function AuthCard({ subtitle, children, footer, width = 400 }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f6fa' }}>
      <div style={{ width, maxWidth: 'calc(100% - 32px)' }}>
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8eaf0', padding: 32 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <LogoMark size={32} />
            <span style={{ fontSize: 20, fontWeight: 700, color: '#1a1f2e' }}>Post Calendar</span>
          </Link>
          <div style={{ fontSize: 13, color: '#8892a4' }}>{subtitle}</div>
        </div>
        {children}
        {footer && <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#8892a4' }}>{footer}</div>}
      </div>
      <LegalLinks />
      </div>
    </div>
  );
}
